import React from "react";
import { connect } from "react-redux";
import UptakeReport from "./uptake/UptakeReport";
import CommunicationsFilter from "./monitor/CommunicationsFilter";
import { MAIN_SECTION } from "../styles";
import Header from "../common/components/Header";

const CompliancePortal = (props) => (
    <div>
        <div style={Object.assign({}, MAIN_SECTION, { width: 1200, margin: "1em auto"})}>
            <Header>Explore Communications</Header>
            <CommunicationsFilter router={props.router}/>
        </div>
        <UptakeReport />
    </div>
);
CompliancePortal.propTypes = {
    router: React.PropTypes.object.isRequired
};
CompliancePortal.displayName = "CompliancePortal";

export default CompliancePortal



/** WEBPACK FOOTER **
 ** ./src/main/javascript/compliance/CompliancePortal.js
 **/